import { Box, Button, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import React, { useEffect, useRef, useState } from 'react'
import { ApiBSCPDF, ApiMonthlyReport } from '../../apiService/Core/Apicall';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../global/config/store';
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice';
import downlod from '../../assets/aldi/images/DownloadImage.png'
import storage from '../../utils/storage';


pdfjs.GlobalWorkerOptions.workerSrc = '//cdnjs.cloudflare.com/ajax/libs/pdf.js/4.8.69/pdf.worker.min.js';

function Bsc() {
    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const dispatch = useDispatch()
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const [data, setdata] = useState<any>();
    const [monthlyreportyear, setmonthlyreportyear] = useState<any>(dayjs(selectedMonth))
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
    const [startMonth, setStartMonth] = React.useState<any>(dayjs(selectedMonth).startOf('year'));
    const [endMonth, setEndMonth] = React.useState<any>(dayjs(selectedMonth).startOf('month'));




    const downloadMonthlyReport = async (type: string) => {
        const data = `?s_month=${startMonth.month() + 1}&e_month=${endMonth.month() + 1}&s_year=${startMonth.year()}&e_year=${endMonth.year()}&questionGroup=${type}&clientGroupName=ALDI${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`;

        try {
            const response = await ApiBSCPDF(data); // responseType: 'blob'
            const csvData = response;
            setdata(response)

            const blob = new Blob([response], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);

            // Create a temporary anchor element
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', type !== "M" ?`ALDIComplianceReport-${endMonth.year()}-${endMonth.month() + 1}.csv`: `ALDIMomentsThatMatter-${endMonth.year()}-${endMonth.month() + 1}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error: any) {
            alert(error);
        }
    };


    // useEffect(() => {
    //     return () => {
    //         if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    //     };
    // }, [pdfUrl]);

    useEffect(() => {
        setEndMonth(dayjs(selectedMonth))
    }, [selectedMonth])
    return (
        <Box>

            <Box className='mt-2 d-flex align-items-center justify-content-between'>
                <Typography className='fw-bold' variant='h6'>BSC Data</Typography>
                <Box className='d-flex align-items-center justify-content-end col-12 col-md-3'>

                    <Box width={{ xs: '75%', md: 'fit-content' }} maxWidth='50px' className='d-flex align-items-center justify-content-end'>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Box display="flex" minWidth={{ xs: "280px", md: '350px' }} width='fit-contentet' gap={{ xs: 1, md: 5 }}>
                                <DatePicker value={startMonth} className='w-50'
                                    label="Start:"
                                    views={['month', 'year']}
                                    format="MMM-YY"
                                    maxDate={endMonth}
                                    onChange={(e) => { setStartMonth(e); }}
                                    sx={{
                                        '& .MuiInputLabel-root': {
                                            fontSize: '14px !important',
                                        }
                                    }}
                                    slots={{
                                        openPickerIcon: ArrowDropDownIcon,
                                    }}
                                />
                                <DatePicker value={endMonth} className='w-50'
                                    label="End: "
                                    views={['month', 'year']}
                                    format="MMM-YY"
                                    sx={{
                                        '& .MuiInputLabel-root': {
                                            fontSize: '14px !important'
                                        }
                                    }}
                                    minDate={startMonth}
                                    onChange={(e: any) => {
                                        const isoString = e?.startOf('month').toISOString();
                                        dispatch(setSelectedMonth(isoString));
                                    }} slots={{
                                        openPickerIcon: ArrowDropDownIcon,
                                    }}
                                />
                            </Box>
                        </LocalizationProvider>
                    </Box>
                </Box>
            </Box>
            {/* <Box className='d-flex align-items-center mt-5 justify-content-center' minHeight={'calc(100vh - 210px)'} gap={1}>
                <Button className='btn-main'
                    onClick={() => { downloadMonthlyReport('C') }}
                >
                    Compliance Excel
                </Button>
                <Button className='btn-main'
                    onClick={() => { downloadMonthlyReport('M') }}
                >
                    Moments That Matter Excel
                </Button>
            </Box> */}
            <Box className='d-flex align-items-center  w-100 h-100'>
                <Box className='d-flex align-items-center  w-100 h-100 gap-3' onClick={() => { downloadMonthlyReport('C,L') }} sx={{ cursor: 'pointer' }}>
                    <Box className='flex-grow-1 h-100 border-20 p-3 px-4' >
                        <Box className='bg-main p-2 px-3 mb-3 border-20' >
                            <Box className='d-flex align-items-start justify-content-between' >
                                <Typography variant='h1' sx={{ color: '#FFFFFF3A' }} fontWeight='400'>01</Typography>
                            </Box>
                            <Typography variant='h6' className='fw-bold' sx={{ color: '#FFFFFF' }} fontWeight='400'>Compliance Excel</Typography>
                        </Box>
                    </Box></Box>

                <Box className='flex-grow-1 w-100 h-100 border-20 p-3 px-4' onClick={() => { downloadMonthlyReport('M') }} sx={{ cursor: 'pointer' }}>
                    <Box className='bg-secondary p-2 px-3 mb-3 border-20'>
                        <Box className='d-flex align-items-start justify-content-between' >
                            <Typography variant='h1' sx={{ color: '#FFFFFF3A' }} fontWeight='400'>02</Typography>
                        </Box>
                        <Typography variant='h6' className='fw-bold' sx={{ color: '#FFFFFF' }} fontWeight='400'>Moments That Matter excel</Typography>
                    </Box>
                </Box>
            </Box>
            <Box>
            </Box>

        </Box>
    )
}

export default Bsc
